import { FC, Fragment, memo } from "react";
import { FormikHandlers } from "formik";
import {
  AutocompleteFilterBody,
  AutocompleteFilterBodyProps,
} from "../AutocompleteFilterBody";
import {
  FilterItem,
  Operator,
  ResourceType,
  useGetUsersMeByTypeStorageTiersQuery,
} from "../../../../../../../../services/cloudchipr.api";
import { FilterItemOperatorType } from "../../../FilterItemOperatorType";

interface StorageTierFilterProps extends AutocompleteFilterBodyProps {
  resourceType: ResourceType;
  filter: FilterItem;
  operators?: Operator[];
  onChange: FormikHandlers["handleChange"];
}

export const StorageTierFilter: FC<StorageTierFilterProps> = memo(
  ({ resourceType, operators, filter, onChange, ...props }) => {
    const { data, isLoading } = useGetUsersMeByTypeStorageTiersQuery({
      type: resourceType,
    });

    return (
      <Fragment>
        <FilterItemOperatorType
          onChange={onChange}
          options={operators}
          value={filter.operator || "in"}
        />

        <AutocompleteFilterBody
          {...props}
          options={data ?? []}
          isLoading={isLoading}
          label="Storage Tier"
          selectedValue={Array.isArray(filter?.value) ? filter.value : []}
        />
      </Fragment>
    );
  },
);
